import { MAX_NAME_LENGTH } from './constants.js';

/**
 * Bereinigt einen eingegebenen Spielernamen.
 *
 * Entfernt Steuer- und Formatzeichen (dazu gehören Zero-Width-Zeichen, mit denen
 * sich sonst zwei optisch identische Namen im selben Raum anlegen ließen),
 * normalisiert Whitespace und kürzt auf die erlaubte Länge.
 */
export function sanitizePlayerName(raw: string): string {
  return raw
    .normalize('NFC')
    .replace(/[\p{Cc}\p{Cf}]/gu, '')
    .replace(/\s+/gu, ' ')
    .trim()
    .slice(0, MAX_NAME_LENGTH);
}

/** Schlüssel für die Eindeutigkeitsprüfung — Namen kollidieren case-insensitiv. */
export function normalizeNameKey(name: string): string {
  return sanitizePlayerName(name).toLocaleLowerCase('de-DE');
}

export function isValidPlayerName(name: string): boolean {
  const clean = sanitizePlayerName(name);
  return clean.length >= 1 && clean.length <= MAX_NAME_LENGTH;
}

/**
 * Leitet den Raumnamen aus dem Host-Namen ab (GDD §5: „Max' Spiel").
 *
 * Deutsche Genitivregel: Namen auf s/ß/x/z bekommen nur einen Apostroph.
 */
export function deriveRoomName(hostName: string): string {
  const clean = sanitizePlayerName(hostName);
  if (clean.length === 0) return 'Offenes Spiel';
  return /[sßxz]$/iu.test(clean) ? `${clean}' Spiel` : `${clean}s Spiel`;
}
